/** ISO 4217 codes supported on marketplace rate cards. */
export const MarketplaceCurrency = {
  NGN: 'NGN',
} as const;
export type MarketplaceCurrency = (typeof MarketplaceCurrency)[keyof typeof MarketplaceCurrency];

/**
 * Known service category codes for vendor capability filters.
 * Additional codes may exist in the catalog; listing responses use `z.string()` for `code`.
 */
export const ServiceCategoryCode = {
  SOUND: 'sound',
  LIGHTING: 'lighting',
  VIDEO: 'video',
  STAGING: 'staging',
  AV: 'av',
  LOGISTICS: 'logistics',
} as const;
export type ServiceCategoryCode = (typeof ServiceCategoryCode)[keyof typeof ServiceCategoryCode];

/** Equipment manifest categories on public vendor listings. */
export const EquipmentCategory = {
  AUDIO: 'audio',
  VIDEO: 'video',
  LIGHTING: 'lighting',
  STAGING: 'staging',
  POWER: 'power',
  OTHER: 'other',
} as const;
export type EquipmentCategory = (typeof EquipmentCategory)[keyof typeof EquipmentCategory];
